export const AI_ENABLED = process.env.REACT_APP_AI_ENABLED === "true";
